import makeStyles from 'e100-react-components/lib/styles/makeStyles';

const useStyles = makeStyles(() => ({
  root: {
    position: 'unset',
    transform: 'none',
    '& > div': {
      paddingTop: 0,
      paddingBottom: 0,
      minWidth: 'unset',
    },
    '& > div > div': {
      width: '100%',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  actions: {
    marginLeft: '40px',
  },
}));

export default useStyles;
